<template>
    <vx-modal v-model:visible="visible" size="sm" padding="standard">
        <template v-slot:header>Request vetting</template>
        <template v-slot:subheader>{{ props.brandId }}</template>

        <div class="flex flex-col gap-4 text-sm text-slate-800">
            <vx-radio-selection v-model="vettingClass">
                <vx-radio-selection-item value="STANDARD" data-test="vetting-class-STANDARD">
                    Standard · $41.50 · Aegis · up to 3 business days
                </vx-radio-selection-item>
            </vx-radio-selection>

            <vx-disclosure appearance="boxed" v-model:active="advanced">
                <template v-slot:header>Advanced</template>
                <template v-slot:content>
                    <p class="mb-3">
                        Enhanced costs $101.50 and only helps when a standard score comes back lower than the brand's
                        size warrants
                    </p>
                    <vx-radio-selection v-model="vettingClass">
                        <vx-radio-selection-item value="ENHANCED" data-test="vetting-class-ENHANCED">
                            Enhanced · $101.50 · Aegis
                        </vx-radio-selection-item>
                    </vx-radio-selection>
                </template>
            </vx-disclosure>

            <div>Provider: <strong data-test="vetting-provider">Aegis</strong>. Each request is a billable charge.</div>
        </div>

        <template v-slot:footer>
            <div class="flex flex-col-reverse gap-4 lg:flex-row">
                <vx-button
                    @click="visible = false"
                    type="button"
                    class="grow lg:w-20 lg:grow-0"
                    size="lg"
                    color="muted"
                >
                    Cancel
                </vx-button>
                <vx-button
                    @click="confirm()"
                    data-test="confirm-vetting"
                    :loading="requesting"
                    type="button"
                    class="grow"
                    size="lg"
                    color="primary"
                >
                    Request {{ 'STANDARD' === vettingClass ? 'standard' : 'enhanced' }} vet
                </vx-button>
            </div>
        </template>
    </vx-modal>
</template>

<script lang="ts" setup>
import { VxButton, VxDisclosure, VxModal, VxRadioSelection, VxRadioSelectionItem } from '@voxie/frontend-components';
import { ref } from 'vue';
import { useToasted } from '~/composables/useToasted';
import { adminTenDlcRegistrationClient } from '~/services';
import type { TcrVettingClassCode } from '~/services/adminTenDlcRegistrationClient.types';
import { catchRequestError } from '~/utils/request';

const props = defineProps<{ brandId: string }>();
const emit = defineEmits<{ requested: [] }>();
const visible = defineModel<boolean>('visible', { default: false });

const toasted = useToasted();

const vettingClass = ref<TcrVettingClassCode>('STANDARD');
const advanced = ref(false);
const requesting = ref(false);

const confirm = async () => {
    if (requesting.value) {
        return;
    }

    requesting.value = true;

    try {
        await adminTenDlcRegistrationClient.requestBrandVetting(props.brandId, {
            vetting_class: vettingClass.value,
            evp_id: 'AEGIS',
        });

        toasted.success('Vetting requested from Aegis.');
        emit('requested');
        visible.value = false;
    } catch (e) {
        toasted.error(catchRequestError(e), { sticky: true });
    } finally {
        requesting.value = false;
    }
};
</script>
